export const INCIDENTS_SET_ELEMENTS = 'INCIDENTS_SET_ELEMENTS';
export const INCIDENTS_SET_DETAILS = 'INCIDENTS_SET_DETAILS';
export const INCIDENTS_CLEAR_ELEMENTS = 'INCIDENTS_CLEAR_ELEMENTS';